import { useEffect, useState } from 'react';
import { Privilege } from '../../api';
import useMe from './useMe';

export default function useHasPrivilege(privilege: Privilege) {
  const [hasPrivilege, setHasPrivilege] = useState(false);
  const { data } = useMe();

  // Remember the latest callback.
  useEffect(() => {
    if (
      data &&
      data.me &&
      data.me.roles &&
      data.me.roles?.flatMap((role) => role?.privileges).filter((p) => p === privilege).length > 0
    ) {
      setHasPrivilege(true);
    } else {
      setHasPrivilege(false);
    }
  }, [data, privilege]);
  return hasPrivilege;
}
